import React, { useState } from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import { USER_TYPE } from '../../constants/index';
import { HowSafeDealWorksModal } from './HowSafeDealWorksModal';
import InfoButton from '../../../../commons/components/InfoButton';
import trackingKeys from '../../../../commons/constants/trackingKeys';

interface HowSafeDealWorksInfoProps {
  isDesktop: boolean;
  trackingExtras: Record<string, any>;
  userType: USER_TYPE;
}

const { howSafeDealWork } = trackingKeys.events.safeDeal;

const HowSafeDealWorksInfo: React.FC<HowSafeDealWorksInfoProps> = ({
  isDesktop,
  trackingExtras,
  userType,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const trackEvent = useTrackEvent();

  const onOpenModalBtnClickHandler = () => {
    trackEvent(howSafeDealWork, null, null, trackingExtras);
    setIsModalVisible(true);
  };

  return (
    <section data-testid="how-sd-works-info-section">
      <InfoButton infoTrigger={onOpenModalBtnClickHandler} btnTextKey="dlv_safedeal_info_button" />
      {isModalVisible && (
        <HowSafeDealWorksModal
          isDesktop={isDesktop}
          closeModal={() => setIsModalVisible(false)}
          userType={userType}
          trackingExtras={trackingExtras}
        />
      )}
    </section>
  );
};

export default HowSafeDealWorksInfo;
